import $ from 'jquery';
import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.attributes({
        launchPackSelector: '[data-launch-pack]',
        categoryButtonSelector: '[data-group=category-pack]',
    });

    this.after('initialize', function() {
        var $logoDesignPack = this.select('categoryButtonSelector').filter('[value=logo-design]');

        this.on('click', {
            launchPackSelector: this.launchPackSelected,
        });

        this.on('change', {
            categoryButtonSelector: this.updateCategory,
        });

        $logoDesignPack.prop('checked', true).trigger('change');
    });

    this.launchPackSelected = function(e) {
        var $radioButton = $(e.currentTarget).find('[data-group]');

        if (!$radioButton.prop('checked')) {
            $radioButton.prop('checked', true).trigger('change');
        }
    };

    this.updateCategory = function(event) {
        var $target = $(event.target);
        var $selectedCategory = this.select('launchPackSelector').filter('[data-selected]');
        var selectedCategoryKey = $selectedCategory
            .find(this.attr.categoryButtonSelector)
            .attr('value');
        var newCategoryKey = $target.attr('value');

        this.selectCategory($target);
        this.unSelectCategory(
            this.select('categoryButtonSelector').filter('[value!=' + newCategoryKey + ']')
        );
        this.trigger('uiBriefCategoryPackSelected:' + newCategoryKey);
        this.trigger('uiBriefCategoryPackDeselected:' + selectedCategoryKey);
    };

    this.selectCategory = function(category) {
        var launchPack = category.closest(this.attr.launchPackSelector);

        category.prop('checked', true);
        launchPack.attr('data-selected', '');
        launchPack.find('[data-children]').show();
    };

    this.unSelectCategory = function(category) {
        var launchPack = category.closest(this.attr.launchPackSelector);

        category.prop('checked', false);
        launchPack.removeAttr('data-selected');
        launchPack.find('[data-children]').hide();
    };
});



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/category-pack-upsell.js